<template>
  <b-tab :title="$t('flexben.clients.partial.events_stated_by_law')"
         :active="(childIndex===0)" :key="childIndex">
    <div class="row ml-1 mr-2 mt-4">
      <div class="col-12 col-md-6">
        <div class="text-18 text-bold">{{ $t("flexben.clients.partial.events_stated_by_law") }}</div>
      </div>
      <div class="col-12 col-md-6 mt-2 mt-md-0">
        <div class="float-md-right d-flex" v-if="isAdmin">
          <label for="law_events_toggle" class="ml-md-auto mb-0 mr-4 mr-2 col-form-label p-0">
            {{$t("flexben.clients.partial.enable_benefit_for_client")}}
          </label>
          <b-form-checkbox id="law_events_toggle"
                           switch
                           v-model="childConfig.is_active">
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="row benefits-order-info mx-3 mt-3 pt-3">
      <div class="col-12 col-md-3">
        <img src="@/assets/images/flexben/utils/benefit-info.svg" alt=""/>
      </div>
      <div class="col-12 col-md-3">
        <p>{{$t("flexben.general.fiscal_treatment")}}</p>
        <p class="text-16 text-bold" v-if=" Object.keys(parentBenefit.global_variable_codes).length === 3">
          {{$t("flexben.benefit.deductibility.none")}}
        </p>
        <p class="text-16 text-bold"
           v-else-if="Object.keys(parentBenefit.global_variable_codes).length < 3 && Object.keys(parentBenefit.global_variable_codes).length > 0">
          {{$t("flexben.benefit.deductibility.partial")}}
        </p>
        <p class="text-16 text-bold" v-else-if=" Object.keys(parentBenefit.global_variable_codes).length === 0">
          {{$t("flexben.benefit.deductibility.complete")}}
        </p>
      </div>
      <div class="col-6 col-md-2">
        <p>{{$t("flexben.general.income_tax")}}</p>
        <p class="text-16 text-bold">{{ parentBenefit.global_variable_codes.includes('impozit-venit') ?
          globalVariables['impozit-venit'].value : 0 }}%</p>
      </div>
      <div class="col-6 col-md-2">
        <p>CAS</p>
        <p class="text-16 text-bold">{{ parentBenefit.global_variable_codes.includes('cas') ?
          globalVariables['cas'].value : 0 }}%</p>
      </div>
      <div class="col-6 col-md-2">
        <p>CASS</p>
        <p class="text-16 text-bold">{{ parentBenefit.global_variable_codes.includes('cass') ?
          globalVariables['cass'].value : 0 }}%</p>
      </div>
      <div class="col-12 col-md-6 col-xl-3 offset-xl-3">
        <p>{{$t("flexben.general.last_annual_date_for_orders")}}</p>
        <p class="text-16 text-bold">
          {{parentBenefit.end_use_day_month.day}}.{{parentBenefit.end_use_day_month.month}}.{{parentBenefit.end_use_day_month.year}}</p>
      </div>
      <div class="col-12 col-md-6 col-xl-3">
        <p>{{$t("flexben.benefit.fields.maximum_legal_value_per_event")}}</p>
        <p class="text-16 text-bold">{{ parentBenefit.data.values.maximum_legal_value_per_event.value }} Lei</p>
      </div>
    </div>
    <div class="row mx-1 mt-4">
      <div class="col-12">
        <span class="text-18 text-bold">{{$t("flexben.clients.partial.legislated_events")}}</span>
      </div>
      <div class="col-12 mt-2" v-if="listOverlapWarningText">
        <div class="alert alert-warning mb-0 py-2">
          <font-awesome-icon icon="exclamation-triangle" class="mr-1"/>
          {{ listOverlapWarningText }}
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="container-fluid px-0 sub-tab-table">
          <div class="table-responsive hover-table">
            <table class="table no-min-width" :key="tableKey">
              <thead>
              <tr>
                <td>
                  {{ $t("flexben.general.event") }}
                </td>
                <td>
                  {{ $t("flexben.general.event_date") }}
                </td>
                <td>
                  {{ $t("flexben.general.top_up_limit")}}
                </td>
                <td>
                  {{ $t("flexben.clients.partial.gender_availability") }}
                </td>
                <td>
                  {{ $t("flexben.clients.partial.for_birthdays") }}
                </td>
                <td>
                  {{ $t("flexben.general.status") }}
                </td>
                <td></td>
              </tr>
              </thead>
              <tbody>
              <template v-if="parentBenefit.events.length > 0">
                <template v-for="(event, index) in parentBenefit.events">
                  <tr
                    v-if="typeof childConfig.legal_events_customization.hasOwnProperty(event.id) !=='undefined'"
                    :key="index"
                    class="trhover" :class="(index%2 ===0) && 'gri-cell'">
                    <td>
                      <div class="d-inline-flex align-items-center">
                        <span class="mobile-icon pr-2 flx-calendar-icon"><font-awesome-icon icon="calendar-alt"/></span>
                        {{ $t('flexben.general.legal_events.'+ event.name) }}
                        <font-awesome-icon
                          v-if="overlappingEventIds[event.id]"
                          icon="exclamation-triangle"
                          class="ml-2 text-warning"
                          :title="listOverlapWarningText"
                        />
                      </div>
                    </td>
                    <td>
                      {{ event.event_date.day }}/{{ event.event_date.month }}/{{ current_year }}
                    </td>
                    <td>
                      {{ childConfig.legal_events_customization[event.id].maximum_topup_limit }} Lei
                    </td>
                    <td>
                      {{ getGenderAvailability(event.gender_availability) }}
                    </td>
                    <td>
                      {{ event.on_birthday ? 'Da':'Nu' }}
                    </td>
                    <td>
                      <span class="cursor-pointer"
                            :class="childConfig.legal_events_customization[event.id].is_active ? 'occasion-active' : 'occasion-inactive'">
                      {{ childConfig.legal_events_customization[event.id].is_active ? $t('flexben.general.status_type.active') : $t('flexben.general.status_type.inactive') }}
                    </span>
                    </td>
                    <td>
                      <button type="button" class="btn action-button"
                              @click="openModalForm(index)">
                        {{$t("flexben.general.btn.see_more")}}
                      </button>
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr class="gri-cell">
                  <td colspan="7" class="text-center">
                    {{$t("flexben.general.no_events")}}
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <company-event-modal v-if="openModal"
                         :type="'company_event'"
                         :openModal="openModal"
                         :formData="formData"
                         :modalAction="modalAction"
                         :errorBag="errorBag"
                         :isLegislated="true"
                         :legislatedEvents="parentBenefit.events"
                         :legalEventsCustomization="childConfig.legal_events_customization"
                         @closeModal="closeModal"
                         @submitForm="submitForm"
                         @toggleStatus="toggleStatus"
                         @scheduleTouched="markScheduleTouched"
    ></company-event-modal>
  </b-tab>
</template>

<script>
import {BFormCheckbox, BTab} from "bootstrap-vue";
import moment from "moment";
import CompanyEventModal from "../modals/CompanyEventModal";
import httpFlexbenService from "@/http/http-flexben";

export default {
  components: {
    "b-tab": BTab,
    "b-form-checkbox": BFormCheckbox,
    "company-event-modal": CompanyEventModal
  },
  name: "SubTabUpLawEvents",
  props: {
    childConfig: {
      type: Object,
      default: function () {
        return {};

      },
      required: true
    },
    clientId: {
      default: null,
      required: true,
    },
    globalVariables: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    childIndex: {
      required: true
    },
    parentBenefit: {
      type: Object,
      default: function () {
        return {};

      },
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: true,
      required: true
    },
  },
  data: function () {
    return {
      httpService: httpFlexbenService.clients.events,
      topLevelParent: this.$parent.$parent.$parent.$parent.$parent.$parent,
      current_year: moment().year(),
      openModal: false,
      formData: {
        type: Object,
        default: function () {
          return {
            occasionId: null,
            occasionIndex: null,
            name: '',
            is_active: true,
            maximum_topup_limit: 0,
            maximum_topup_limit_per_minor: 0,
            date: {
              day: null,
              month: null,
              year: null,
            },
            is_birthday: false,
            gender_availability: {
              male: true,
              female: true,
            },
            has_limit_per_child: false,
          };
        },
        required: true
      },
      errorBag: {},
      modalAction: 'update',
      tableKey: 0,
      scheduleTouched: false,
    };
  },
  computed: {
    activeLegislatedIntervals() {
      const events = this.parentBenefit.events || [];
      const customization = this.childConfig.legal_events_customization || {};
      const intervals = [];

      events.forEach((event) => {
        const config = customization[event.id];
        if (!config || !config.is_active || event.on_birthday) {
          return;
        }
        const interval = this.resolveEventValidityInterval(event, config);
        if (!interval) {
          return;
        }
        intervals.push({
          id: event.id,
          name: event.name,
          start: interval.start,
          end: interval.end,
        });
      });

      return intervals;
    },
    overlappingEventIds() {
      const overlaps = {};
      const intervals = this.activeLegislatedIntervals;

      for (let i = 0; i < intervals.length; i++) {
        for (let j = i + 1; j < intervals.length; j++) {
          const first = intervals[i];
          const second = intervals[j];
          if (first.start.isSameOrBefore(second.end) && second.start.isSameOrBefore(first.end)) {
            overlaps[first.id] = true;
            overlaps[second.id] = true;
          }
        }
      }

      return overlaps;
    },
    hasCompletePlatformSchedule() {
      return !!(this.formData.platform_open_date && this.formData.platform_close_date);
    },
    listOverlapWarningText() {
      const overlapping = this.activeLegislatedIntervals.filter(
        (item) => this.overlappingEventIds[item.id]
      );
      if (!overlapping.length) {
        return '';
      }
      const names = overlapping.map((item) =>
        this.$t('flexben.general.legal_events.' + item.name)
      ).join(', ');
      return this.$t('flexben.clients.partial.legislated_events_overlap_warning', {events: names});
    },
  },
  methods: {
    resolveEventValidityInterval(event, customization) {
      if (!event || !event.event_date || !event.event_date.day || !event.event_date.month) {
        return null;
      }
      const year = event.event_date.year || this.current_year;
      const eventDate = moment({
        year: year,
        month: parseInt(event.event_date.month, 10) - 1,
        day: parseInt(event.event_date.day, 10),
      }).startOf('day');

      if (!eventDate.isValid()) {
        return null;
      }

      const openOffset = customization.platform_open_offset_days != null
        ? customization.platform_open_offset_days
        : null;
      const closeOffset = customization.platform_close_offset_days != null
        ? customization.platform_close_offset_days
        : null;

      if (openOffset != null && closeOffset != null) {
        return {
          start: eventDate.clone().add(openOffset, 'days').startOf('day'),
          end: eventDate.clone().add(closeOffset, 'days').endOf('day'),
        };
      }

      const openDate = customization.platform_open_date
        ? moment(customization.platform_open_date, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true)
        : null;
      const closeDate = customization.platform_close_date
        ? moment(customization.platform_close_date, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true)
        : null;

      if (openDate && openDate.isValid() && closeDate && closeDate.isValid()) {
        return {
          start: openDate.startOf('day'),
          end: closeDate.endOf('day'),
        };
      }

      return {
        start: eventDate.clone().subtract(30, 'days').startOf('day'),
        end: eventDate.clone().add(30, 'days').endOf('day'),
      };
    },
    openModalForm(eventIndex) {
      let event = this.parentBenefit.events[eventIndex];
      this.modalAction = 'update';
      this.scheduleTouched = false;
      let genderAvailability;
      if (event.gender_availability === 'MALE') {
        genderAvailability = {
          male: true,
          female: false,
        };
      } else if (event.gender_availability === 'FEMALE') {
        genderAvailability = {
          male: false,
          female: true,
        };
      } else {
        genderAvailability = {
          male: true,
          female: true,
        };
      }
      const scheduleDates = this.resolveSchedulePickerDate(
        event,
        this.childConfig.legal_events_customization[event.id]
      );
      this.formData = {
        occasionId: event.id,
        occasionIndex: eventIndex,
        name: this.$t('flexben.general.legal_events.' + event.name),
        is_active: this.childConfig.legal_events_customization[event.id].is_active,
        maximum_topup_limit: this.childConfig.legal_events_customization[event.id].maximum_topup_limit,
        maximum_topup_limit_per_minor: this.childConfig.legal_events_customization[event.id].maximum_topup_limit_per_minor,
        date: {
          day: parseInt(event.event_date.day),
          month: parseInt(event.event_date.month),
          year: event.event_date.year,
        },
        is_birthday: event.on_birthday,
        gender_availability: genderAvailability,
        has_limit_per_child: event.has_limit_per_child,
        platform_open_date: scheduleDates.open,
        platform_close_date: scheduleDates.close,
      };
      this.openModal = true;
    },
    closeModal: function () {
      this.topLevelParent.loading = false;
      this.openModal = false;
      this.errorBag = {};
      this.scheduleTouched = false;
      this.formData = {
        occasionId: null,
        name: '',
        is_active: '',
        maxTopUpLimit: 0,
        date: null,
        is_birthday: false,
        gender_availability: {
          male: true,
          female: true,
        },
        platform_open_date: null,
        platform_close_date: null,
      };
    },
    submitForm() {
      this.errorBag = {};
      const shouldValidateSchedule = this.scheduleTouched || this.hasCompletePlatformSchedule;
      if (shouldValidateSchedule) {
        const scheduleErrors = this.validatePlatformSchedule();
        if (Object.keys(scheduleErrors).length > 0) {
          this.errorBag = scheduleErrors;
          this.openModal = true;
          return;
        }
      }

      this.topLevelParent.loading = true;
      this.openModal = false;

      const schedulePayload = this.buildSchedulePayloadForSubmit();
      let formData = {
        is_active: this.formData.is_active,
        name: this.formData.name,
        event_date: this.formData.date,
        maximum_topup_limit: this.formData.maximum_topup_limit,
        on_birthday: this.formData.is_birthday,
        gender_availability: this._getGenderAvailability(),
        maximum_topup_limit_per_minor: this.formData.maximum_topup_limit_per_minor,
        platform_open_offset_days: schedulePayload.platform_open_offset_days,
        platform_close_offset_days: schedulePayload.platform_close_offset_days,
        platform_open_date: schedulePayload.platform_open_date,
        platform_close_date: schedulePayload.platform_close_date,
      };

      let event = this.parentBenefit.events[this.formData.occasionIndex];
      this.httpService.updateEvent(this.clientId, this.parentBenefit.id, event.id, formData)
        .then(function (response) {
          this.childConfig.legal_events_customization[response.data.id].is_active = response.data.is_active;
          this.childConfig.legal_events_customization[response.data.id].maximum_topup_limit = response.data.maximum_topup_limit;
          this.childConfig.legal_events_customization[response.data.id].maximum_topup_limit_per_minor = response.data.maximum_topup_limit_per_minor;
          this.childConfig.legal_events_customization[response.data.id].platform_open_offset_days =
            response.data.platform_open_offset_days != null ? response.data.platform_open_offset_days : null;
          this.childConfig.legal_events_customization[response.data.id].platform_close_offset_days =
            response.data.platform_close_offset_days != null ? response.data.platform_close_offset_days : null;
          this.childConfig.legal_events_customization[response.data.id].platform_open_date = response.data.platform_open_date || null;
          this.childConfig.legal_events_customization[response.data.id].platform_close_date = response.data.platform_close_date || null;
          this.tableKey++; // forces re-render of table for status change
          this.topLevelParent.loading = false;
          this.closeModal();
        }.bind(this))
        .catch(function (error) {
          this.topLevelParent.loading = false;
          this.openModal = true;
          this.errorBag = error.response.data.error_fields;
        }.bind(this));
    },
    getEventAnchorDate(event, referenceDate) {
      let year = event.event_date.year;
      if (!year && referenceDate) {
        year = moment(referenceDate).year();
      }
      if (!year) {
        year = moment().year();
      }

      return moment({
        year: year,
        month: parseInt(event.event_date.month, 10) - 1,
        day: parseInt(event.event_date.day, 10),
      }).startOf('day');
    },
    resolveSchedulePickerDate(event, customization) {
      const openOffset = customization.platform_open_offset_days;
      const closeOffset = customization.platform_close_offset_days;
      const hasBothOffsets = openOffset != null && closeOffset != null;

      if (hasBothOffsets) {
        const eventDate = this.getEventAnchorDate(event);
        return {
          open: eventDate.clone().add(openOffset, 'days').toDate(),
          close: eventDate.clone().add(closeOffset, 'days').toDate(),
        };
      }

      const openDate = customization.platform_open_date
        ? this.parseScheduleDate(customization.platform_open_date)
        : null;
      const closeDate = customization.platform_close_date
        ? this.parseScheduleDate(customization.platform_close_date)
        : null;

      if (openDate && closeDate) {
        return {open: openDate, close: closeDate};
      }

      return {open: null, close: null};
    },
    markScheduleTouched() {
      this.scheduleTouched = true;
    },
    buildScheduleOffsets() {
      if (!this.formData.platform_open_date && !this.formData.platform_close_date) {
        return {
          platform_open_offset_days: null,
          platform_close_offset_days: null,
        };
      }

      const event = this.parentBenefit.events[this.formData.occasionIndex];
      const scheduleReference = this.formData.platform_open_date || this.formData.platform_close_date;
      const eventDate = this.getEventAnchorDate(event, scheduleReference);
      return {
        platform_open_offset_days: this.formData.platform_open_date
          ? moment(this.formData.platform_open_date).startOf('day').diff(eventDate, 'days')
          : null,
        platform_close_offset_days: this.formData.platform_close_date
          ? moment(this.formData.platform_close_date).startOf('day').diff(eventDate, 'days')
          : null,
      };
    },
    buildSchedulePayloadForSubmit() {
      if (this.scheduleTouched || this.hasCompletePlatformSchedule) {
        const offsets = this.buildScheduleOffsets();
        return {
          platform_open_offset_days: offsets.platform_open_offset_days,
          platform_close_offset_days: offsets.platform_close_offset_days,
          platform_open_date: this.formatScheduleDate(this.formData.platform_open_date),
          platform_close_date: this.formatScheduleDate(this.formData.platform_close_date),
        };
      }

      const customization = this.childConfig.legal_events_customization[this.formData.occasionId] || {};
      return {
        platform_open_offset_days: customization.platform_open_offset_days != null
          ? customization.platform_open_offset_days
          : null,
        platform_close_offset_days: customization.platform_close_offset_days != null
          ? customization.platform_close_offset_days
          : null,
        platform_open_date: customization.platform_open_date || null,
        platform_close_date: customization.platform_close_date || null,
      };
    },
    validatePlatformSchedule() {
      const errors = {};
      const open = this.formData.platform_open_date;
      const close = this.formData.platform_close_date;

      if (!open && !close) {
        return errors;
      }

      if (!open || !close) {
        if (!open) {
          errors.platform_open_date = 'required';
        }
        if (!close) {
          errors.platform_close_date = 'required';
        }
        return errors;
      }

      const event = this.parentBenefit.events[this.formData.occasionIndex];
      const scheduleReference = open || close;
      const eventDate = this.getEventAnchorDate(event, scheduleReference);
      const openDate = moment(open).startOf('day');
      const closeDate = moment(close).startOf('day');
      const minOpen = eventDate.clone().subtract(30, 'days');
      const maxClose = eventDate.clone().add(30, 'days');

      if (openDate.isBefore(minOpen) || openDate.isAfter(maxClose)) {
        errors.platform_open_date = 'exceeds_event_window';
      }
      if (closeDate.isBefore(minOpen) || closeDate.isAfter(maxClose)) {
        errors.platform_close_date = 'exceeds_event_window';
      }
      if (openDate.isAfter(closeDate)) {
        errors.platform_open_date = 'invalid_range';
        errors.platform_close_date = 'invalid_range';
      }

      return errors;
    },
    parseScheduleDate(value) {
      if (!value) {
        return null;
      }
      return moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true).isValid()
        ? moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true).toDate()
        : null;
    },
    formatScheduleDate(value) {
      if (!value) {
        return null;
      }
      return moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : null;
    },
    toggleStatus() {
      this.formData.is_active = !this.formData.is_active;
    },
    getGenderAvailability(gender) {
      if (gender === 'MALE') {
        return 'Barbati';
      } else if (gender === 'FEMALE') {
        return 'Femei';
      } else {
        return 'Ambele genuri';
      }
    },
    _getGenderAvailability() {
      if (this.formData.gender_availability.male && this.formData.gender_availability.female) {
        return 'BOTH';
      } else if (!this.formData.gender_availability.male && this.formData.gender_availability.female) {
        return 'FEMALE';
      } else if (this.formData.gender_availability.male && !this.formData.gender_availability.female) {
        return 'MALE';
      } else {
        return 'BOTH';
      }
    },
  }
}
</script>
